import React from 'react';
import {
  Tabs,
} from "antd";
import Device from "./Device";

export default ({children, ...props}) => {
  return <Tabs {...props}>
    {_.reject(children, c => !c || !c.props || c.props.show === false || c.props.hidden)}
  </Tabs>
}